import React from 'react';
import { Spinner } from '@custom-components';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const LoadingWrapper = styled('div')`
  display: flex;
  justify-content: space-around;
  background-color: transparent;
  align-items: center;
  min-width: 50px;
  min-height: 50px;
`;

const LoadingOverlayWrapper = styled('div')`
  display: flex;
  justify-content: space-around;
  position: absolute;
  padding-top: 50px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(256, 256, 256, 0.75);
  z-index: 2;
  min-width: 50px;
  min-height: 50px;
`;

export function Loading({ size, thickness }) {
  return (
    <LoadingWrapper data-testid="spinnerLoading">
      <Spinner size={size} thickness={thickness} />
    </LoadingWrapper>
  );
}

Loading.propTypes = {
  size: PropTypes.number,
  thickness: PropTypes.number
};

Loading.defaultProps = {
  size: 45,
  thickness: 4
};

export function LoadingOverlay() {
  return (
    <LoadingOverlayWrapper>
      <Spinner />
    </LoadingOverlayWrapper>
  );
}

export default Loading;
